import React from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';
import Button from '../../../components/ui/Button';

const RequestCard = ({ request, onSubmitOffer, currentLanguage }) => {
  const translations = {
    en: {
      budget: 'Budget',
      carrierFee: 'Carrier Fee',
      delivery: 'Delivery',
      verified: 'Verified',
      rating: 'Rating',
      submitOffer: 'Submit Offer',
      potentialEarning: 'Potential Earning'
    },
    ko: {
      budget: '예산',
      carrierFee: '운송 수수료',
      delivery: '배송',
      verified: '인증됨',
      rating: '평점',
      submitOffer: '제안 제출',
      potentialEarning: '예상 수익'
    }
  };

  const t = translations?.[currentLanguage];

  const formatCurrency = (amount) => {
    return `${amount?.toLocaleString()}원`;
  };

  const formatDate = (dateString) => {
    return dateString;
  };

  return (
    <div className="bg-card rounded-lg shadow-elevation-md p-4 md:p-6 hover:shadow-elevation-lg transition-base">
      <div className="flex flex-col md:flex-row gap-4">
        <div className="flex-1 space-y-3">
          <div className="flex items-start justify-between gap-3">
            <div className="flex-1">
              <h3 className="text-lg md:text-xl font-heading font-semibold text-foreground mb-2">
                {request?.itemName}
              </h3>
              <div className="flex items-center gap-2 mb-3">
                <span className="px-2 py-1 bg-secondary/10 text-secondary text-xs font-medium rounded caption">
                  {request?.category}
                </span>
                <div className="flex items-center gap-1">
                  <Icon name="MapPin" size={14} color="var(--color-muted-foreground)" />
                  <span className="text-sm text-muted-foreground caption">
                    {request?.originCountry} → {request?.destinationCountry}
                  </span>
                </div>
              </div>
            </div>
          </div>

          <div className="flex items-center gap-3">
            <Image
              src={request?.buyer?.avatarUrl || 'https://via.placeholder.com/40'}
              alt={`${request?.buyer?.fullName || 'Buyer'} profile picture`}
              className="w-10 h-10 rounded-full object-cover"
            />
            <div>
              <div className="flex items-center gap-2">
                <span className="text-sm font-medium text-foreground">
                  {request?.buyer?.fullName || 'Unknown Buyer'}
                </span>
                {request?.buyer?.isVerified && (
                  <Icon name="CheckCircle" size={14} color="var(--color-success)" />
                )}
              </div>
              <div className="flex items-center gap-1">
                <Icon name="Star" size={12} color="var(--color-warning)" />
                <span className="text-xs text-muted-foreground caption">
                  {request?.buyer?.rating?.toFixed(1) || '0.0'}
                </span>
              </div>
            </div>
          </div>

          <div className="grid grid-cols-2 gap-3">
            <div className="space-y-1">
              <p className="text-xs text-muted-foreground caption">{t?.budget}</p>
              <p className="text-sm font-semibold text-foreground data-text">
                {formatCurrency(request?.budget)}
              </p>
            </div>
            <div className="space-y-1">
              <p className="text-xs text-muted-foreground caption">{t?.carrierFee}</p>
              <p className="text-sm font-semibold text-primary data-text">
                {formatCurrency(request?.carrierFee)}
              </p>
            </div>
            <div className="space-y-1">
              <p className="text-xs text-muted-foreground caption">{t?.delivery}</p>
              <p className="text-sm font-medium text-foreground data-text">
                {formatDate(request?.deliveryDate)}
              </p>
            </div>
            <div className="space-y-1">
              <p className="text-xs text-muted-foreground caption">{t?.potentialEarning}</p>
              <p className="text-sm font-semibold text-success data-text">
                {formatCurrency(request?.carrierFee)}
              </p>
            </div>
          </div>

          {request?.notes && (
            <div className="bg-muted/50 rounded-lg p-3">
              <p className="text-sm text-muted-foreground">{request?.notes}</p>
            </div>
          )}
        </div>

        <div className="flex md:flex-col gap-2">
          <Button
            variant="default"
            size="default"
            iconName="Send"
            iconPosition="left"
            onClick={() => onSubmitOffer(request?.id)}
            fullWidth
            className="md:w-40"
          >
            {t?.submitOffer}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default RequestCard;